var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLight = function SvgLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2h2v5h-2zM21.687 8.9l3.506-3.507 1.414 1.415-3.506 3.506zM25 15h5v2h-5zM21.687 23.1l1.414-1.414 3.506 3.506-1.414 1.415zM15 25h2v5h-2zM5.394 25.192 8.9 21.686l1.414 1.415-3.506 3.506zM2 15h5v2H2zM5.394 6.808l1.414-1.415L10.314 8.9 8.9 10.314zM16 12a4 4 0 1 1-4 4 4.005 4.005 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6Z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "<Transparent Rectangle>",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }));
};
export default SvgLight;